import { render } from "./WordBannerProp.vue?vue&type=template&id=3582033b&scoped=true"
import script from "./WordBannerProp.vue?vue&type=script&lang=js"
export * from "./WordBannerProp.vue?vue&type=script&lang=js"

import "./WordBannerProp.vue?vue&type=style&index=0&id=3582033b&scoped=true&lang=less"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3582033b"]])

export default __exports__